import { Card, Row, Col, Typography } from "antd";
const { Title, Text } = Typography;

export default function Analytics({ data }) {

  const acompanamiento = data.filter((item) => item.acompanamiento === "X").length;
  const capacitacion = data.filter((item) => item.capacitacion === "X").length;
  const totalProyectos = [...new Set(data.map((i) => i.proyecto))].length;

  return (
    <div style={{ marginBottom: 24, marginLeft: 13 }}>
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col xs={12} md={6}>
          <Card style={{ borderRadius: 10,  textAlign: "center" }}>
            <Text type="secondary">Total Registros</Text>
            <Title level={3} style={{ marginTop: 8 }}>
              {data.length}
            </Title>
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card style={{ borderRadius: 10, textAlign: "center"}}>
            <Text type="secondary">Proyectos</Text>
            <Title level={3} style={{ marginTop: 8, color: "#f59e0b" }}>
              {totalProyectos}
            </Title>
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card style={{ borderRadius: 10, textAlign: "center"}}>
            <Text type="secondary">Acompañamientos</Text>
            <Title level={3} style={{ marginTop: 8, color: "#3b82f6" }}>
              {acompanamiento}
            </Title>
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card  style={{ borderRadius: 10, textAlign: "center" }}>
            <Text type="secondary">Capacitaciones</Text>
            <Title level={3} style={{ marginTop: 8, color: "#10b981" }}>
              {capacitacion}
            </Title>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
